import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';

export const useCalendarStyles = makeStyles(() => ({
  weekViewCalendar: {
    '& .fc-header-toolbar': {
      borderRadius: 4,
      boxShadow: '0px 0px 4px 0px #cacaca',
      padding: 5,
    },
    '& .fc-view-harness': {
      boxShadow: '0px 0px 4px 0px #cacaca',
      padding: 5,
    },
    '& .fc-icon-chevron-left, .fc-icon-chevron-right': {
      fontSize: '2rem !important',
    },
    '& .fc-license-message': {
      zIndex: '2 !important',
    },
    '& .fc-toolbar-chunk': {
      display: 'flex',
    },
    '& .fc-toolbar-chunk .fc-button-primary': {
      color: 'black',
      backgroundColor: 'unset',
      borderColor: '#bac2ca',
    },
    '& .fc-today-button': {
      textTransform: 'capitalize',
    },
    '& .fc-toolbar-chunk .fc-next-button , .fc-toolbar-chunk .fc-prev-button': {
      borderColor: 'transparent',
    },
    '& .fc .fc-prev-button:hover , .fc .fc-next-button:hover': {
      borderColor: 'transparent !important',
    },
    '& .fc .fc-button-primary:hover': {
      backgroundColor: 'unset',
      color: 'black',
      borderColor: '#bac2ca',
    },
    '& .fc .fc-button:focus': {
      boxShadow: 'unset !important',
    },
    '& .fc-col-header-cell, th.fc-timegrid-axis': {
      background: '#f6f6f6',
      padding: 5,
      border: 'unset',
      position: 'relative',
      cursor: 'default !important',
    },
    '& tbody tr:nth-child(2)': {
      padding: '0 !important',
      border: 'unset',
      display: 'none',
    },
    '& .fc-col-header-cell-cushion': {
      width: 70,
      textAlign: 'center',
      color: '#72bcf6 !important',
      cursor: 'default !important',
    },
    '& .fc .fc-timegrid-col.fc-day-today': {
      backgroundColor: 'transparent',
    },
    '& .fc-col-header-cell.fc-day-today': {
      backgroundColor: '#f6f6f6 !important',
      padding: '0 !important',
      '& div': {
        margin: '0 auto',
        background: '#72bcf6',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& a': {
          color: '#fff !important',
        },
      },
    },
    '& .fc-col-header-cell.fc-day-today:after': {
      background: '#72bcf6 !important',
    },
    '& th.fc-col-header-cell:not(:last-child):after': {
      content: '""',
      width: 1,
      height: 20,
      background: '#cccccc',
      position: 'absolute',
      right: 0,
      top: '50%',
      transform: 'translate(0, -50%)',
    },
    '& .fc-button:not(:last-child)': {
      borderRadius: '4px !important',
    },
    '& table.fc-scrollgrid.fc-scrollgrid-liquid': {
      border: 'none',
      height: '100%',
    },
    '& .fc .fc-timegrid-slot-label': {
      verticalAlign: 'top',
    },
    '& a.fc-col-header-cell-cushion': {
      color: 'rgba(0, 0, 0, 0.58)',
      fontSize: '12px',
    },
    '& .fc-timegrid-axis-cushion, .fc-timegrid-slot-label-cushion': {
      padding: '0 12px',
      color: 'rgba(0, 0, 0, 0.38)',
    },
    '& .fc-scrollgrid-section-liquid > td, .fc-scrollgrid-section > td': {
      borderRight: 'none',
    },
    '& .fc-timegrid-event .fc-event-main': {
      padding: 0,
    },
    '& .fc-daygrid-day-events': {
      display: 'none',
    },
  },
}));

export const renderLegend = (COLOR_LEGEND) => (
  <Box
    marginTop={1}
    style={{
      display: 'flex',
      justifyContent: 'space-around',
      flexWrap: 'wrap',
    }}
  >
    {Object.entries(COLOR_LEGEND).map(([key, { color, text }]) => {
      return (
        <Box
          key={key}
          style={{
            display: 'inline-flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
          }}
        >
          <Box
            style={{
              border: '1px solid lightgray',
              margin: '2px 5px',
              width: '30px',
              flexShrink: 0,
              height: '15px',
              backgroundColor: color,
            }}
          />
          <Typography variant="caption">{text}</Typography>
        </Box>
      );
    })}
  </Box>
);
